import { GridColDef } from '@mui/x-data-grid';
import { renderDisplayName } from './RenderDisplayName';
import { renderRoles } from './RenderRoles';
import { renderUserEnabled } from './RenderUserEnabled';
import { renderDetailedInfo } from './RenderDetailedInfo';

export const columns = (
  onToggleUserRole: (email: string, role: string, assign: boolean) => Promise<void>,
  onToggleUserStatus: (email: string, assign: boolean) => Promise<void>,
): GridColDef[] => {
  return [
    { field: 'email', headerName: 'Email', flex: 1 },
    { field: 'name', renderCell: renderDisplayName, headerName: 'Surname, Name', flex: 1 },
    { field: 'enabled', renderCell: (params) => renderUserEnabled(params, onToggleUserStatus), headerName: 'User Enabled', width: 120, maxWidth: 120, minWidth: 120 },
    { field: 'SuperAdministrator', renderCell: (params) => renderRoles(params, onToggleUserRole), headerName: 'SuperAdministrator', width: 175, maxWidth: 175, minWidth: 175 },
    { field: 'Administrator', renderCell: (params) => renderRoles(params, onToggleUserRole), headerName: 'Administrator', width: 140, maxWidth: 140, minWidth: 140 },
    { field: 'Operator', renderCell: (params) => renderRoles(params, onToggleUserRole), headerName: 'Operator', width: 110, maxWidth: 110, minWidth: 110 },
    { field: 'detailedInfo', renderCell: renderDetailedInfo, headerName: 'Detailed Info', width: 120, maxWidth: 120, minWidth: 120 },
  ];
}
